import { render, staticRenderFns } from "./SingleDocumentLink.vue?vue&type=template&id=6f64b1b0"
import script from "./SingleDocumentLink.vue?vue&type=script&lang=js"
export * from "./SingleDocumentLink.vue?vue&type=script&lang=js"
import style0 from "./SingleDocumentLink.vue?vue&type=style&index=0&id=6f64b1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports